import { sessionSchema, type LoginRequest, type Session } from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export const fetchSession = (signal?: AbortSignal): Promise<Session> =>
  apiRequest('/auth/me', { schema: sessionSchema, signal })

export const login = (payload: LoginRequest): Promise<Session> =>
  apiRequest('/auth/login', { method: 'POST', body: payload, schema: sessionSchema })

export const logout = (): Promise<void> => apiRequest('/auth/logout', { method: 'POST' })
